import { useEffect, useState } from 'react';

/**
 * Returns true when the viewport width is below the Tailwind `md` breakpoint
 * (768px). Re-runs on window resize so it picks up landscape/portrait flips
 * without a full reload.
 *
 * Centralized here so React components don't have to repeat the same resize
 * listener boilerplate. Server-side rendering safe (returns false during the
 * first render before the effect runs).
 */
export function useIsMobile(breakpointPx = 768) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpointPx;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const update = () => setIsMobile(window.innerWidth < breakpointPx);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [breakpointPx]);

  return isMobile;
}
